const API = {
  API_BASE_URL: 'https://api-staging.pluralonline.com',
  API_AUTH_URL: 'https://api-staging.pluralonline.com',
  API_PAYOUTS_URL: 'https://api-staging.pluralonline.com',
  SETTLEMENT_API_BASE_URL: 'https://api-staging.pluralonline.com',
  SETTLEMENT_API_AUTH_URL: 'https://api-staging.pluralonline.com',
  API_WEBHOOK_KEY: 'xPjkgEv+sI4kCL1DxH2TEg==',
  API_ONBOARDING_BASE_URL: 'self-serve-onboarding-service-uat.v2.pinepg.in',
};

export default {
  API,
};
